declare var DOMPurify: any;
'use strict';
module Patersons {

  export interface ArticleScope extends ng.IScope {
    events: Patersons.ArticleCtrl;
    article: Feed;
    section: string;
    isError: boolean;
  }

  export class ArticleCtrl extends ResearchBaseCtrl {

    scope: Patersons.ArticleScope;
    $analytics: any;
    location: ng.ILocationService;
    window: ng.IWindowService;
    stateParams: angular.ui.IStateProvider;
    state: angular.ui.IStateService;
    http: ng.IHttpService;
    sce: ng.ISCEService;
    researchFeedService: ResearchFeedService;

    static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$sce', 'researchFeedService', 'navigationService', '$analytics','article'];

    constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, $sce, researchFeedService, navigationService, $analytics, article) {
      super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
      this.scope = $scope;
      this.location = $location;
      this.window = $window;
      this.state = $state;
      this.stateParams = $stateParams;
      this.http = $http;
      this.researchFeedService = researchFeedService;
      this.sce = $sce;
      this.$analytics = $analytics;
      this.scope.events = this;
      this.scope.isError = false;


      this.load(article);
    }

    load(article) {
      this.scope.section = this.stateParams['section'];
      console.log(this.scope.section);
      if(article){
        console.log(article);
          this.scope.article = article;

          this.$analytics.eventTrack('article view', {  
            category: 'Research Article', 
            label:  article.title + " - " + window.location.href
          });

          this.scope.isError = false;
      }else{
        this.scope.isError = true;
      }
    }

    toTrustedHTML(html){
      return this.sce.trustAsHtml(html);
    }

    sanitizeHTMLforView(html){
      var clean = DOMPurify.sanitize(html, {FORBID_TAGS: ['style', 'class'], ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling'], ADD_TAGS: ['iframe']});
      return clean;

    }
  }
}
